export default "__VITE_ASSET__v51TOqkR__"